<script setup lang="ts">
import SettingsMainMenu from "@/components/shared/settings/SettingsMainMenu.vue";
import SettingsSubMenu from "@/components/shared/settings/SettingsSubMenu.vue";
import SettingsContentPanel from "@/components/shared/settings/SettingsContentPanel.vue";
import { shouldExpandSettingsSubmenu } from "@/components/shared/settings/settingsSections";
import { useCanAccessPlatformControl } from "@/composables/shared/useSectionPermissions";
import { useDisplay } from "vuetify";
import type { IAdminPageProps } from "@/utils/adminInterfaces";

definePage({
  meta: {
    layout: "admin",
    title: "generic.entity.adminSettings",
    checkPrivileges: () => {
      return useCanAccessPlatformControl().value;
    },
  },
});

defineProps<IAdminPageProps>();

const { lgAndUp } = useDisplay();
</script>

<template>
  <div
    class="tw:h-full tw:w-full tw:rounded-tl-xl tw:bg-admin-settings tw:!p-0"
    v-if="lgAndUp"
  >
    <div class="tw:flex tw:h-full tw:w-full">
      <SettingsMainMenu
        :menu-items="categories"
        :active-menu-key="activeCategory.key"
        @menu-select="handleCategorySelect"
      />

      <SettingsSubMenu
        :sub-menu-items="activeCategory.sections || []"
        :active-sub-menu-key="activeSection.key"
        :show-submenu="shouldExpandSettingsSubmenu(activeCategory)"
        @submenu-select="handleSectionSelect"
      />

      <SettingsContentPanel
        :active-main-menu-key="activeCategory.key"
        :active-sub-menu-key="activeSection.key"
      />
    </div>
  </div>
  <div
    v-else
    class="tw:h-full tw:w-full"
  >
    <SettingsContentPanel
      :active-main-menu-key="activeCategory.key"
      :active-sub-menu-key="activeSection.key"
    />
  </div>
</template>
